export default __webpack_public_path__ + "static/media/up-chevron.7b3fe79e.svg";